import FullLogoIcon from './logo/FullLogoIcon';

export { FullLogoIcon };
